import { render } from "./page15.vue?vue&type=template&id=659446c4&scoped=true"
import script from "./page15.vue?vue&type=script&lang=js"
export * from "./page15.vue?vue&type=script&lang=js"

import "./page15.vue?vue&type=style&index=0&id=659446c4&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-659446c4"]])

export default __exports__